import { post, downLoadFile } from '../../xhr/fetch'
import { OPERATION_CENTER_PREFIX } from '../../config'

// 操作日志列表
export const GET_OPERATE_LOG_LIST = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/log/v1/queryOper`, data)
}

// 导出操作日志
export const EXPORT_OPERATE_LOG_LIST = (data) => {
  return downLoadFile(`${OPERATION_CENTER_PREFIX}/log/v1/exportOperLog`, data)
}

// 系统日志列表
export const GET_SYS_LOG_LIST = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/log/v1/querySys`, data)
}

// 导出系统日志
export const EXPORT_SYS_LOG_LIST = (data) => {
  return downLoadFile(`${OPERATION_CENTER_PREFIX}/log/v1/exportSysLog`, data)
}

// 错误日志列表
export const GET_ERROR_LOG_LIST = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/log/v1/queryErr`, data)
}

// 导出错误日志
export const EXPORT_ERROR_LOG_LIST = (data) => {
  return downLoadFile(`${OPERATION_CENTER_PREFIX}/log/v1/exportErrLog`, data)
}
